module.exports = __webpack_public_path__ + "img/qr_code.02e83e6d.svg";